export const IS_PROD = process.env.ENVIRONMENT?.toLowerCase() === 'production';
export const DEV_LOGS_ENABLED = [
  process.env.DEV_LOGS_ENABLED,
  process.env.NEXT_PUBLIC_DEV_LOGS_ENABLED,
].includes('true');
